import React from 'react';
import clsx from 'clsx';
import { Box } from '../Box';
import { createDescendantContext, createDescendantsStepper, DescendantsProvider, useDescendantsContextSelector, useDescendantsStepper, } from '../Descandants';
import { ActionListItem } from './ActionListItem';
import { ActionListSeparator } from './ActionListSeparator';
import { ActionListGroup } from './ActionListGroup';
import { ActionListToggle } from './ActionListToggle';
import './ActionList.css';
export const ActionListDescendantsContext = createDescendantContext('ActionListDescendantsContext');
const actionListDescendantsStepper = createDescendantsStepper({ rotate: true });
var KeyboardActions;
(function (KeyboardActions) {
    KeyboardActions[KeyboardActions["FIRST"] = 0] = "FIRST";
    KeyboardActions[KeyboardActions["LAST"] = 1] = "LAST";
    KeyboardActions[KeyboardActions["NEXT"] = 2] = "NEXT";
    KeyboardActions[KeyboardActions["PREVIOUS"] = 3] = "PREVIOUS";
    KeyboardActions[KeyboardActions["CLICK"] = 4] = "CLICK";
})(KeyboardActions || (KeyboardActions = {}));
function ActionListComponent(props) {
    const { children, elementType = 'ul', className, variant, ...rest } = props;
    const setActiveIndex = useDescendantsContextSelector(ActionListDescendantsContext, ({ setActiveIndex }) => setActiveIndex);
    const stepper = useDescendantsStepper(ActionListDescendantsContext, actionListDescendantsStepper);
    const onKeyDown = (e) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const { key, target } = e;
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            /** Skip ActionList's events when we are focused on an input-like fields. */
            return;
        }
        const actionKey = (() => {
            if (key === 'Home')
                return KeyboardActions.FIRST;
            if (key === 'End')
                return KeyboardActions.LAST;
            if (key === 'ArrowDown')
                return KeyboardActions.NEXT;
            if (key === 'ArrowUp')
                return KeyboardActions.PREVIOUS;
            if (key === 'Enter' || key === ' ')
                return KeyboardActions.CLICK;
            return;
        })();
        switch (actionKey) {
            case KeyboardActions.FIRST:
                e.preventDefault();
                (_b = (_a = stepper.getFirstDescendant()) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.focus();
                break;
            case KeyboardActions.LAST:
                e.preventDefault();
                (_d = (_c = stepper.getLastDescendant()) === null || _c === void 0 ? void 0 : _c.element) === null || _d === void 0 ? void 0 : _d.focus();
                break;
            case KeyboardActions.NEXT:
                e.preventDefault();
                (_f = (_e = stepper.getNextDescendant()) === null || _e === void 0 ? void 0 : _e.element) === null || _f === void 0 ? void 0 : _f.focus();
                break;
            case KeyboardActions.PREVIOUS:
                e.preventDefault();
                (_h = (_g = stepper.getPreviousDescendant()) === null || _g === void 0 ? void 0 : _g.element) === null || _h === void 0 ? void 0 : _h.focus();
                break;
            case KeyboardActions.CLICK:
                e.preventDefault();
                (_k = (_j = stepper.getActiveDescendant()) === null || _j === void 0 ? void 0 : _j.element) === null || _k === void 0 ? void 0 : _k.click();
                break;
        }
    };
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-action-list', {
            [`mollie-ui-action-list--${variant}`]: variant,
        }, className), elementType: elementType, role: "menu", onKeyDown: onKeyDown, onBlur: () => {
            setActiveIndex(-1);
        } }, children));
}
export function ActionList(props) {
    return (React.createElement(DescendantsProvider, { context: ActionListDescendantsContext },
        React.createElement(ActionListComponent, { ...props })));
}
ActionList.Group = ActionListGroup;
ActionList.Item = ActionListItem;
ActionList.Toggle = ActionListToggle;
ActionList.Separator = ActionListSeparator;
//# sourceMappingURL=ActionList.js.map